import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface IProps {

}

export function RouteError(props: IProps) {
    const navigate = useNavigate()
    useEffect(() => {
        navigate('/');
    }, [navigate]);
    return (
        <div className="route-error-wrapper">
            <h1>RouteError</h1>
        </div>
    )
}
